// Centered empty state for the Playground's compare grid: optional auth slot,
// then the composer.
//
// Replaces mcpjam's `MultiModelStartersEmptyLayout`, whose reason for existing
// was the row of sample-prompt chips above the composer. Those are gone
// (David, 2026-08-22) — an operator arrives with the prompt they want to run
// against their clients, and canned "Try one of these" chips were noise in
// front of it.
import type { ReactNode } from "react";

interface PlaygroundEmptyCompareLayoutProps {
  isAuthLoading: boolean;
  /** Loading spinner, upsell panel, or null. */
  authPrimarySlot: ReactNode;
  chatInputSlot: ReactNode;
}

export function PlaygroundEmptyCompareLayout({
  isAuthLoading,
  authPrimarySlot,
  chatInputSlot,
}: PlaygroundEmptyCompareLayoutProps) {
  return (
    <div
      className="flex min-h-0 flex-1 overflow-hidden"
      data-testid="multi-model-empty-state-shell"
    >
      <div
        className="flex h-full min-h-0 flex-1 items-center justify-center overflow-hidden px-4"
        data-testid="multi-model-empty-state-body"
      >
        <div className="w-full max-w-4xl shrink-0 space-y-6 py-8">
          {authPrimarySlot}
          {!isAuthLoading ? (
            <div className="w-full">{chatInputSlot}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
